import Track from '../../../v2/utils/tracking';

const UvLazyLoader = () => import(
  /* webpackChunkName: "uvApi" */
  'uv-api'
).then(uV => uV)
  .catch((error) => {
    Track.error(`Failed to load uv-api ${error}`);
  });
export default UvLazyLoader;
